import React from "react";
import Tickets from "../../AppLib/AppLib_Tickets";
import Utils from "../../utils/utils";
import TicketView from "./TicketView";
const { STATUS } = Tickets;

const TicketCard = ({ ticket, index, onClick }) => {
  const status = STATUS[ticket.status];

  return (
    <div className="p-6 bg-white rounded-xl shadow-lg  flex justify-between items-center cursor-pointer gap-3 xs:flex-col hover:shadow-2xl transition-shadow duration-300">
      <div
        role="button"
        className="flex gap-4 w-3/4 xs:w-full"
        onClick={onClick}
      >
        <div className="flex flex-col justify-between gap-y-2">
          <h4 className="text-lg font-semibold text-gray-600 cursor-pointer sm:truncate">
            {ticket.title}
          </h4>
          <div>
            <span className="text-[#3B3435] text-sm">
              Last Updated on{" "}
              <span className="font-semibold">
                {" "}
                {Utils.formatDateTime(ticket.createdAt, true)}
              </span>
            </span>
          </div>
        </div>
      </div>
      <div className="flex  justify-center items-center xs:self-end">
        <p
          className={`font-[Open_Sans] font-semibold text-sm tracking-widest  px-4 py-1 rounded-md shadow-sm uppercase ${status.text} ${status.bg}`}
        >
          {status.name}
        </p>
      </div>
    </div>
  );
};

export default TicketCard;
